import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const LearningIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        d="M8.44104 1.1043C8.17311 0.965235 7.82678 0.965235 7.559 1.1043L0.365126 5.00139C-0.121709 5.25431 -0.121709 5.74893 0.365126 6.00173L7.559 9.89914C7.82678 10.0382 8.17311 10.0382 8.44104 9.89914L14.005 6.88468L14.0165 10.0173C14.0185 10.5648 14.4627 11.0076 15.01 11.0076C15.5568 11.0076 16 10.5642 16 10.0173V5.50172C16 5.31481 15.8783 5.12787 15.6348 5.00139L8.44104 1.1043Z"
        fill="currentColor"
      />
      <path
        d="M7.75802 11.4821L3.3712 9.04962C3.33411 9.02905 3.29241 9.01826 3.25 9.01826C3.11193 9.01826 3 9.13023 3 9.26835V12.2243C3 12.3172 3.05149 12.4025 3.13371 12.4457L7.76946 14.8826C7.91508 14.9591 8.08902 14.9591 8.23463 14.8826L12.8704 12.4457C12.9526 12.4025 13.0041 12.3172 13.0041 12.2243V9.26821C13.0041 9.22581 12.9933 9.18411 12.9728 9.14703C12.9059 9.02621 12.7537 8.98252 12.633 9.04944L8.2427 11.4822C8.09193 11.5658 7.90877 11.5657 7.75802 11.4821Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default LearningIcon;
